import React from 'react';

import formatCompleteDate from '~/services/formatCompleteDate';
import { format } from 'date-fns';
import formatValue from '~/utils/formatValue';
import {
  Container,
  Restaurant,
  Footer,
  TotalRow,
  MotoboysTable,
} from './styles';

const PrintBillDetails = React.forwardRef(({ item, restaurant, user }, ref) => {
  return (
    <Container ref={ref}>
      <React.Fragment key={item?.id}>
        <Restaurant style={{ borderBottom: 'none' }}>
          <strong>{restaurant?.fantasy_name}</strong>
        </Restaurant>
        <Restaurant>
          <strong>Comanda #{item.id} </strong>
        </Restaurant>

        <TotalRow>
          <span>{formatCompleteDate(item?.created_at)}</span>
        </TotalRow>
        <TotalRow>
          <span>Cliente:</span>
          <span>{user?.name}</span>
        </TotalRow>
        <TotalRow>
          <span>Telefone:</span>
          <span>{user?.phone}</span>
        </TotalRow>
        <TotalRow>
          <span>Total da comanda:</span>
          <span>
            {' '}
            {item?.table?.table_type === 'delivery'
              ? formatValue(item?.total_delivery_price)
              : formatValue(item?.total_service_price)}
          </span>
        </TotalRow>

        <MotoboysTable>
          <thead>
            <tr>
              <th>Qtd.</th>
              <th>Item</th>
              <th>$ Unitário</th>
              <th>$ Consumido</th>
            </tr>
          </thead>
          <tbody>
            {item?.bills?.map((bill) =>
              bill.order_baskets.map((basket) =>
                basket.orders.map((order) => (
                  <tr key={order.id}>
                    <td>{order.amount}</td>
                    <td>{order.product?.name}</td>
                    <td>
                      {formatValue(
                        (Number(order.price) || 0) +
                        (Number(order.complements_price) || 0)
                      )}
                    </td>
                    <td>{formatValue(order.total_service_price)}</td>
                  </tr>
                ))
              )
            )}
          </tbody>
        </MotoboysTable>

        <Footer>
          <span>Desenvolvido por Takeat!</span>
        </Footer>
      </React.Fragment>
    </Container>
  );
});

export default PrintBillDetails;
